export const FETCH_USERREPRESENTATIVE_REQUEST = 'FETCH_USERREPRESENTATIVE_REQUEST';
export const FETCH_USERREPRESENTATIVE_SUCCESS = 'FETCH_USERREPRESENTATIVE_SUCCESS';
export const FETCH_USERREPRESENTATIVE_FAILURE = 'FETCH_USERREPRESENTATIVE_FAILURE';

export const UPDATE_USERREPRESENTATIVE_REQUEST = 'UPDATE_USERREPRESENTATIVE_REQUEST';
export const UPDATE_USERREPRESENTATIVE_SUCCESS = 'UPDATE_USERREPRESENTATIVE_SUCCESS';
export const UPDATE_USERREPRESENTATIVE_FAILURE = 'UPDATE_USERREPRESENTATIVE_FAILURE';

export const AUTHENTICATE_REQUEST = 'AUTHENTICATE_REQUEST';
export const AUTHENTICATE_SUCCESS = 'AUTHENTICATE_SUCCESS';
export const AUTHENTICATE_FAILURE = 'AUTHENTICATE_FAILURE';

export const LINK_REQUEST = 'LINK_REQUEST';
export const LINK_SUCCESS = 'LINK_SUCCESS';
export const LINK_FAILURE = 'LINK_FAILURE';
